module.exports = __webpack_public_path__ + "img/wf-finishing-position-17.90c54e58.svg";